import React from 'react';

const Header = ({ title = 'Account Action' }) => (
  <div
    style={{
      width: '100%',
      padding: '16px 20px',
      borderTopLeftRadius: 12,
      borderTopRightRadius: 12,
      background: 'linear-gradient(180deg, rgba(0,102,255,0.25) 0%, rgba(0,102,255,0.15) 100%)',
      borderBottom: '1px solid rgba(0,0,0,0.06)',
      fontWeight: 700,
      color: '#0f172a',
      textAlign: 'center',
    }}
  >
    {title}
  </div>
);

const SuccessContent = ({ message }) => (
  <div style={{ textAlign: 'center', padding: 24 }}>
    <div style={{ fontSize: 64, color: '#10B981', lineHeight: 1 }}>✓</div>
    <div style={{ fontSize: 24, fontWeight: 800, color: '#1E40AF', marginTop: 12 }}>Success!</div>
    <div style={{ color: '#334155', marginTop: 10 }}>{message}</div>
    <button
      style={{
        marginTop: 16,
        padding: '10px 18px',
        borderRadius: 10,
        border: '1px solid rgba(0,0,0,0.08)',
        background: '#eef2ff',
        color: '#1E40AF',
        cursor: 'pointer',
      }}
      onClick={() => window.close()}
    >
      Close Window
    </button>
  </div>
);

const ErrorContent = ({ message }) => (
  <div style={{ textAlign: 'center', padding: 24 }}>
    <div style={{ fontSize: 48, color: '#DC2626', lineHeight: 1 }}>!</div>
    <div style={{ fontSize: 24, fontWeight: 800, color: '#991B1B', marginTop: 12 }}>Something went wrong</div>
    <div style={{ color: '#334155', marginTop: 10 }}>{message}</div>
  </div>
);

const LoadingContent = () => (
  <div style={{ textAlign: 'center', padding: 24 }}>
    <div className="spinner" style={{ width: 36, height: 36, border: '3px solid #e5e7eb', borderTopColor: '#3b82f6', borderRadius: '50%', margin: '0 auto', animation: 'spin 1s linear infinite' }} />
    <div style={{ color: '#334155', marginTop: 10 }}>Processing your request...</div>
    <style>{'@keyframes spin{to{transform:rotate(360deg)}}'}</style>
  </div>
);

const Card = ({ children }) => (
  <div
    style={{
      width: '100%',
      maxWidth: 720,
      background: '#fff',
      border: '1px solid rgba(0,0,0,0.08)',
      borderRadius: 12,
      boxShadow: '0 10px 30px rgba(0,0,0,0.08)',
    }}
  >
    {children}
  </div>
);

const Backdrop = ({ show }) => (
  <div
    style={{
      display: show ? 'block' : 'none',
      width: '100%',
      borderRadius: 8,
      background: 'linear-gradient(180deg, #2C7CF6 0%, #2E7CF6 100%)',
      padding: 28,
    }}
  />
);

const ActionBoxPreview = ({ state = 'success', withBackground = false, title = 'Account Action', message }) => {
  const content =
    state === 'loading' ? (
      <LoadingContent />
    ) : state === 'error' ? (
      <ErrorContent message={message || 'Invalid or expired action code. Please try again.'} />
    ) : (
      <SuccessContent message={message || 'Your email has been updated and verified!'} />
    );

  return (
    <div style={{ maxWidth: 760, margin: '0 auto' }}>
      {withBackground && <Backdrop show />}
      <Card>
        <Header title={title} />
        {content}
      </Card>
    </div>
  );
};

export default ActionBoxPreview;


